import { createSelector } from "@reduxjs/toolkit";
import {
  API_STATUS_FAILURE,
  API_STATUS_LOADING,
  API_STATUS_SUCCESS,
} from "../Constants/SliceAndThunkConstants";

const selectApiResponses = (state, sliceName, thunkName) => {
  const stateResponseMethod = `${thunkName}Response`;

  if (!state?.[sliceName]?.[stateResponseMethod]) {
    return null;
  }
  const isSuccess =
    state?.[sliceName]?.[stateResponseMethod].status === API_STATUS_SUCCESS;
  const isFailure =
    state?.[sliceName]?.[stateResponseMethod].status === API_STATUS_FAILURE;
  const isLoading =
    state?.[sliceName]?.[stateResponseMethod].status === API_STATUS_LOADING;

  const description = state?.[sliceName]?.[stateResponseMethod]?.error?.message
    ? state?.[sliceName]?.[stateResponseMethod]?.error?.message
    : state?.[sliceName]?.[stateResponseMethod]?.message?.description;

  return {
    isSuccess: isSuccess,
    isFailure: isFailure,
    isLoading: isLoading,
    description: description,
  };
};

/**
 * @description Selector method to fetch the API response for all slices and thunks.
 * @param state Object from redux containing entire state.
 * @param sliceName Name of the redux slice under which the API call was made.
 * @param thunkName Thunk/Method name which was dispatched for making the API call.
 */
export const manageApiResponseSelector = createSelector(
  [selectApiResponses],
  (apiResponses) => ({
    apiResponses,
  })
);
